<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col offset-md="1" offset-lg="2">
        <Container :paddedTopBottom="false">
          <h2>Daphne Lammertse</h2>
          <p>
            Mijn eerste kennismaking met osteopathie was via de paardensport. De
            therapeut sprak met zoveel passie over haar vak dat mijn interesse
            meteen werd gewekt. Toen ik later zelf door een osteopaat werd
            behandeld, groeide die interesse alleen maar verder. Gezondheid,
            bewegen en de zorg hebben mij altijd al aangesproken. Deze
            ervaringen hebben uiteindelijk geleid tot mijn keuze om zelf
            osteopathie te gaan studeren.
          </p>
          <p>
            Wat mij vanaf het begin aansprak in de osteopathie, is de
            persoonlijke en holistische benadering. Geen mens is hetzelfde en
            daarom geloof ik ook niet in een standaardbehandeling. Ik vind het
            belangrijk om de tijd te nemen, echt naar iemand te luisteren en
            samen te ontdekken wat er achter de klachten schuilgaat. Daarbij
            kijk ik naar het lichaam als één geheel, omdat een klacht niet
            altijd ontstaat op de plek waar de pijn wordt gevoeld, maar ergens
            anders zijn oorsprong kan hebben.
          </p>
          <p>
            Iedere patiënt brengt een nieuwe puzzel met zich mee; juist dat
            maakt mijn werk zo interessant. Door goed te luisteren, zorgvuldig
            te onderzoeken en alle puzzelstukjes met elkaar te verbinden, ga ik
            op zoek naar de oorzaak van de klacht. Ik vind het mooi om die
            verbanden te ontdekken en mensen niet alleen te helpen hun klachten
            te verminderen, maar ook meer inzicht te geven in hun eigen lichaam.
          </p>
          <p>
            Als therapeut ben ik rustig, betrokken en nieuwsgierig. Ik vind het
            belangrijk dat mensen zich op hun gemak voelen en de ruimte ervaren
            om hun verhaal te vertellen. Samen werken we aan een behandeling die
            aansluit bij de persoon achter de klacht. Buiten mijn werk ben ik
            graag actief in de sportschool en vind ik ontspanning in een goed
            boek.
          </p>

          <img src="../../assets/team/daphne.jpg" alt="Daphne" />
        </Container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Container from "../../components/Container.vue";
export default {
  name: "Daphne",
  components: { Container }
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 2rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  margin-top: 3rem;
}

h3 {
  font-size: 1.4rem;
  text-transform: uppercase;
  margin-bottom: 0.2rem;
  color: #747769;
  em {
    font-style: normal;
    color: #747769;
  }
}

img {
  max-width: 100%;
  max-height: 480px;
  width: auto;
}
</style>
